export const iconFontAwesomeMovingTruckMoving = (
	<i className="fa-solid fa-truck-moving"></i>
);
